import {observable} from "mobx";

export enum PTFileInfoType {
    PT_PDF = "PT_PDF",
    PT_IMAGE = "PT_PDF_IMG",
    PT_VIDEO = "PT_VIDEO"
}

export enum UserStatusType {
    READY = "READY",
    START = "START",
    PDF_UPLOAD = "PDF_UPLOAD",
    COMPLETED = "COMPLETED",
    ENCODING_COMPLETED = "ENCODING_COMPLETED"
}

export enum PTSlideEventType {
    NEXT = "NEXT"
}

export interface IUser {
    domain: string;
    id: number
    name: string;
    ptCount: number;
    recruitNoticeName: string;
    recruitSectorName: string;
    screeningName: string;
    subjectName: string;
    userCk: string;
    userStatusType: UserStatusType;
}

export interface IPTPdf {
    id: number;
    fileDir: string;
    fileInfoType: PTFileInfoType;
    fileName: string;
    fileUrl: string;
}

export interface IPTImage {
    id: number;
    fileDir: string;
    fileInfoType: PTFileInfoType;
    fileName: string;
    fileUrl: string;
}

export interface IPTSlideEvent {
    indexTime: number;
    slideEventType: PTSlideEventType;
    slideIndex: number;
}

export interface IPTVideo {
    id: number;
    fileDir: string;
    fileInfoType: PTFileInfoType;
    fileName: string;
    fileUrl: string;
}

export default interface IPTInformation {
    user: IUser;
    ptPdf: IPTPdf;
    ptImages: IPTImage[];
    ptSlideEvents: IPTSlideEvent[]
    ptVideo: IPTVideo;

    currentSlide: number;
    currentMarkerIndex: number;
    tempSlide: number;
    isBlind: boolean;
    isLoaded: boolean;
    isConvertPDF: boolean;

    init: () => void;

    totalPage: number;
    loadingPage: number;
}